<template>
  <div
    v-if="mostrar"
    class="modal fade show modal-certificado-wrapper"
    style="display: block; z-index: 9999;"
    tabindex="-1"
    role="dialog"
    @click.self="fechar"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" @click.stop style="z-index: 10000;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Certificado</h5>
          <div class="modal-header-actions">
            <button
              v-if="urlPdf && !loading"
              type="button"
              class="btn-download-header"
              @click="baixar"
            >
              <i class="icofont-download mr-1"></i>
              Baixar certificado
            </button>
            <button
              type="button"
              class="close"
              @click="fechar"
            >
              <span>&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body p-0">
          <div v-if="loading" class="text-center p-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-3">Carregando certificado...</p>
          </div>
          <div v-else-if="urlPdf" class="pdf-container">
            <iframe
              :src="pdfSrcComToolbarOculta"
              class="pdf-viewer"
              frameborder="0"
            ></iframe>
          </div>
          <div v-else class="text-center p-5">
            <p class="text-muted">Erro ao carregar o certificado.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalCertificado',
  props: {
    mostrar: {
      type: Boolean,
      default: false,
    },
    urlPdf: {
      type: String,
      default: null,
    },
    nomeArquivo: {
      type: String,
      default: 'certificado.pdf',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pdfSrcComToolbarOculta() {
      if (!this.urlPdf) return null
      const hasHash = this.urlPdf.includes('#')
      const suffix = 'toolbar=0&navpanes=0&scrollbar=0'
      if (hasHash) {
        // Evita duplicar parâmetros se já existirem
        return this.urlPdf.includes('toolbar=0')
          ? this.urlPdf
          : `${this.urlPdf}&${suffix}`
      }
      return `${this.urlPdf}#${suffix}`
    },
  },
  methods: {
    fechar() {
      this.$emit('fechar')
    },
    baixar() {
      if (!this.urlPdf) return
      const link = document.createElement('a')
      link.href = this.urlPdf
      link.download = this.nomeArquivo || 'certificado.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style scoped>
.modal-certificado-wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 90%;
  margin: 1.75rem auto;
}

.modal-content {
  border-radius: 8px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
}

.modal-header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-download-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid #0fafd7;
  background-color: #0fafd7;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.btn-download-header:hover {
  background-color: #0c8bb0;
  border-color: #0c8bb0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.modal-header .close {
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  font-size: 2rem;
  font-weight: 300;
  line-height: 1;
  color: #6c757d;
  opacity: 0.5;
  cursor: pointer;
  transition: opacity 0.2s;
}

.modal-header .close:hover {
  opacity: 1;
  color: #212529;
}

.modal-body {
  padding: 0;
  min-height: 500px;
}

.pdf-viewer {
  width: 100%;
  height: 80vh;
  min-height: 500px;
  border: none;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
  border-width: 0.3em;
}
</style>
